import React from "react";
import { useTranslation } from "react-i18next";
import { Stand } from "../../../data/interfaces";
import _environment from "../../../_environment/_environment";
import { ANALYTICS_EVENTS, trackAnalyticsEvent } from "../../../utils/analytics";
import Button from "../../shared/button/Button";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  stand: Stand;
}

const ChatButton = ({ stand, ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const onClick = () => {
    if (!!stand.mattermost && !!stand.mattermost.slug) {
      // Track event
      trackAnalyticsEvent(ANALYTICS_EVENTS.STAND_CHAT, {
        stand: { id: stand?.id, name: stand?.name },
      });

      window.open(`${_environment.mattermost.URL}/${stand.mattermost.slug}`, "_blank");
    }
  };

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      {!!stand.mattermost && !!stand.mattermost.slug && (
        <Button onClick={onClick} className="btn btn-primary">
          {t("pages.standDetail.chat")}
          <i className="fas fa-comments"></i>
        </Button>
      )}
    </>
  );
};
export default ChatButton;
